module.exports = __webpack_public_path__ + "img/userCaseNav1.2f2b4064.png";